<template>
  <div class="file-explorer-row">
    <span v-if="item.length === null">
      <v-icon class="margin-right-small">mdi-folder</v-icon>
      <span>{{ item.name }}</span>
    </span>
    <span v-if="item.length !== null">
      <v-icon
        v-if="!item.isItemLoading"
        color="primary"
        class="margin-right-small"
      >{{ icon }}
      </v-icon>
      <span class="loader-span"
            v-if="item.isItemLoading"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          :size="24"
        ></v-progress-circular>
      </span>
      <span :class="{'font-primary-color':item.isFileUsed}">{{ item.name }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name:  "FileExplorerVideoRow",
  props: {
    item: Object,
    icon: String
  }
}
</script>

<style scoped>
.file-explorer-row {
  max-width: 550px;
  overflow-wrap: break-word;
}

.loader-span {
  display: inline-block;
  width: 24px;
  margin-right: 5px
}

@media (max-width: 800px) {
  .file-explorer-row {
    max-width: 300px;
    overflow-wrap: break-word;
  }
}
</style>
